import "../../../css/Buttons/YesButton.css";

const YesButton = ({ buttonText, onClick }) => {
  return (
    <button className="Yes-Button-Container" onClick={onClick}>
      <div className="AML-Text-Body">{buttonText || "Yes"}</div>
    </button>
  );
};

export default YesButton;
